export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const ERROR_NOTIFICATION = "ERROR_NOTIFICATION";
export const LOGOUT = "LOGOUT";

export const TOKEN_EXPIRED = "TOKEN_EXPIRED";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
